
import AppButton from "./AppButton.vue"

export default {
  components: {
    AppButton
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    image: {
      type: Object,
      required: true
    },
    backgroundColor: {
      type: String,
      required: true
    },
    voteKey: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      flipCard: "default",
      disableVote: false,
      newBranding: process.env.VUE_APP_NEW_BRANDING === "true"
    }
  },
  computed: {
    getCardClass() {
      let flip = this.flipCard === "default" ? "" : " energy-vote-card--flipped"
      let background = this.disabled
        ? " energy-vote-card--disabled"
        : " energy-vote-card--" + this.backgroundColor

      if (this.backgroundColor === "earth" && this.newBranding) {
        background = " energy-vote-card--earth-new"
      }

      return "energy-vote-card " + background + flip
    }
  },
  methods: {
    triggerVote() {
      this.$emit("energyVote", this.voteKey)
    },
    handleClick() {
      this.flipCard = this.flipCard === "click" ? "default" : "click"
    },
    handleMouseEnter() {
      this.flipCard = "enter"
      /*
        On mobile tap both mouse enter and click events are called.
        This is here to stop click event clicking the button after card flipped.
      */
      this.disableVote = true
      setTimeout(() => {
        this.disableVote = false
      }, 450)
    }
  }
}
